import { Observable } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { mapTo, switchMap } from 'rxjs/internal/operators';
import State from 'src/application/core/State';
import OrderDraftSaveRequested from '../events/OrderDraftSaveRequested';
import SaveOrderDraftSucceed from '../events/OrderSaveDraftSucceed';
import OrderSafeDraftFailed from '../events/OrderSafeDraftFailed';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import catchErrors from '../../core/backend/catchErrors';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> => {
    return event$.pipe(
        ofType(OrderDraftSaveRequested.type),
        switchMap(() => {
            return backend
                .put(`${api()}users/${state$.value.user.customerId}/orders/draft`, JSON.stringify(state$.value.order.order!))
                .pipe(
                    mapTo(new SaveOrderDraftSucceed(state$.value.order.order!)),
                    catchErrors(new OrderSafeDraftFailed())
                );
        })
    );
};



// WEBPACK FOOTER //
// ./src/application/order/epic/orderDraftUpdate.ts